import axios from "axios"
import firebase from "firebase"

import { AppEnv } from "../app/app.env"
import { AppLocalStorage } from "./app-local-storage"

/**
 * Classe responsavel pela manipulação dos usuários
 */
export class UserService {

  static updateUserData(user) {

    AppLocalStorage.set("user", user)

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/update-user-mobile-data`

    return axios.put(scheduleApiUrl, user, { headers: AppEnv.scheduleApi.headers })
  }

  static getSectorUsers(sector) {

    const loggedUser = firebase.auth().currentUser
    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-sector-users`
    const body = { sector }

    return axios.post(scheduleApiUrl, body, { headers: AppEnv.scheduleApi.headers })
      .then((response) => {

        let users = []

        response.data.forEach((user) => {

          if (user.email == loggedUser.email)
            return

          user.isLoadingPicture = true

          users.push(user)
        })

        return users
      })
  }

  static getUsersDetail(userIds) {

    const scheduleApiUrl = `${AppEnv.scheduleApi.url}/mobile-users-detail`

    return axios.post(scheduleApiUrl, { userIds }, { headers: AppEnv.scheduleApi.headers })
      .then((response) => {

        let users = []

        response.data.forEach((user) => {

          user.isLoadingPicture = true

          users.push(user)
        })

        return users
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/user.ts